const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/gp-activities-staging' : 'api/gp-activities'
const urls = {
  queryInviteInfo: 'GET /api/userinvite/service/queryInviteInfo',
  sendInviteBull: 'GET /api/userinvite/service/sendInviteBull',
  // 报告会抽奖配置
  reportConfig: 'POST /api/activities/luckyDraw/config',
  // 报告会抽奖删除
  deleteConfig: 'DELETE /api/activities/luckyDraw/config/:id',
  // 报告会抽奖更新
  updateConfig: 'PUT /api/activities/luckyDraw/config/:id',
  // 报告会抽奖获取
  getConfig: 'GET /api/activities/luckyDraw/config/:targetType/:targetId',
  // 抽奖开奖
  drawKaiJiang: 'POST /api/activities/luckyDraw/config/draw/:drawId',
  // 滚动抽奖开始
  drawStart: 'post /api/activities/luckyDraw/config/draw/:drawId/start',
  /**
   * 财商问卷调查相关
   */
  getPaper: 'get /api/activities/papers/user/paper/:id', // 获取试卷
  getNewPaper: 'get /api/activities/papers/user/paper/:id/new', //获取最新的试卷
  answer: 'put /api/activities/papers/user/answer/:userPid/:qid', // 用户答题
  submitPaper: 'put /api/activities/papers/user/paper/:userPid/submit' // 提交试卷

}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS
